// extracted by mini-css-extract-plugin
export default {"button":"Rm-z","reviewSort":"Sm-z"};